import * as actions from "./Type";
import Instance from "../util/Instance";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import setToken from "../util/SetToken";
import Swal from "sweetalert2";
import swal from "sweetalert";
export const Login = (user) => {
  return async (dispatch) => {
    dispatch({ type: actions.LOGIN_REQUEST });
    try {
      const res = await Instance.post(`/api/v1/signinAdminAgent`, { ...user });
      if (res.status === 200) {
        const token = res.data.data.token;
        const user = res.data.data.user;
        localStorage.setItem("token_GPC_admin", token);
        localStorage.setItem("user", JSON.stringify(user));
        dispatch({
          type: actions.LOGIN_SUCCESS,
          payload: {
            token,
            user,
          },
          isAuth: true,
        });
        window.location.reload();
      }
    } catch (error) {
      dispatch({
        type: actions.LOGIN_FAILURE,
        payload: {
          error: error,
        },
      });
      Swal.fire({
        title: "OPS",
        text: "Invalid of Phone or Password",
        icon: "error",
        html: `Please Check Phone Or Password`,
        confirmButtonText: "Ok",
        timer: 2000,
      });
    }
  };
};

export const isUserLoggedIn = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/RealEstateBySign`, config);
      if (res.status === 200) {
        dispatch({
          type: actions.LOGIN_SUCCESS,
          payload: {
            Auth: true,
            user: res.data.data,
          },
          L_status: true,
        });
      }
    } catch (error) {
      dispatch({
        type: actions.LOGIN_FAILURE,
        payload: {
          Auth: null,
        },
      });
      // localStorage.removeItem("token_GPC_admin");
      // localStorage.removeItem("user");
      // window.location.reload();
    }
  };
};

export const LogOut = () => {
  return (dispatch) => {
    try {
      dispatch({ type: actions.LOGOUT_REQUEST });
      const token = localStorage.removeItem("token_GPC_admin");
      const user = localStorage.removeItem("user");
      dispatch({
        type: actions.LOGOUT_SUCCESS,
        payload: token,
        user,
      });

      toast.success("Logout User");
    } catch (error) {}
  };
};

export const Update_Profile = (user) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };

    try {
      const res = await Instance.put(
        `/api/v1/updateRealEstate`,
        { ...user },
        config
      );
      if (res.status === 200) {
        const user = res.data.data.doc;
        localStorage.setItem("user", JSON.stringify(user));
        dispatch({
          type: actions.UPDATE_PROFILE_SUCCESS,
          payload: res.data.data.doc,
        });
        swal({
          title: "Good job!",
          text: "Update User Profile Successfuly !",
          icon: "success",
          timer: 1000,
        });
      }
    } catch (error) {
      toast.error("Update User Profile Faieled");
    }
  };
};

export const Update_Password = (user) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.put(
        `/api/v1/ChangeRealEstatePassword`,
        { ...user },
        config
      );
      if (res.status === 200) {
        const user = res.data.data.user;
        const token = res.data.data.token;
        localStorage.setItem("token_GPC_admin", token);
        localStorage.setItem("user", JSON.stringify(user));
        dispatch({
          type: actions.CHANGE_PASSWORD,
          payload: {
            user,
            token,
          },
        });
        swal({
          title: "Good job!",
          text: "Update Password Successfuly !",
          icon: "success",
          timer: 1000,
        });
      }
    } catch (error) {
      toast.error("Incorect Old Password");
    }
  };
};

export const Update_Image = (user) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.put(
        `/api/v1/UpdateImageRealEstate`,
        { ...user },
        config
      );
      if (res.status === 200) {
        const user = res.data.data.doc;
        localStorage.setItem("user", JSON.stringify(user));

        dispatch({
          type: actions.CHANGE_IMAGE,
          payload: {
            user,
          },
        });
        swal({
          title: "Good job!",
          text: "Update Image Successfuly Done!",
          icon: "success",
          timer: 1000,
        });
      }
    } catch (error) {
      toast.error("Error of Update Image");
    }
  };
};

export const Lost_Password_Update = (phone, user) => {
  return async (dispatch) => {
    try {
      const res = await Instance.put(
        `/api/v1/updateRealEstateLostPass/${phone}`,
        {
          ...user,
        }
      );
      dispatch({
        type: actions.LOST_PASSWORD_UPDATE,
        payload: res.data.data,
      });
      swal({
        title: "Good job!",
        text: "Update  Password Successfuly Done!",
        icon: "success",
        timer: 1000,
      });
    } catch (error) {}
  };
};

export const Lost_Password_Check = (phone, user) => {
  return async (dispatch) => {
    try {
      const res = await Instance.get(`/api/v1/checkRealEstates/${phone}`, {
        ...user,
      });
      dispatch({
        type: actions.LOST_PASSWORD_CHECK,
        payload: {
          res: res.data.data,
          status: res.data.status,
        },
      });
      toast.success("Checked Successfuly Done!");
    } catch (error) {}
  };
};

export const Open_With_Password = (data, component) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(`/api/v1/OpenRE`, { ...data }, config);
      if (res.data.data) {
        dispatch({
          type: actions.OPEN_PASSWORD,
          payload: component,
        });
      }
    } catch (error) {}
  };
};
